import { memo, useEffect, useState } from 'react';
import { Card, Grid, IconButton, Typography, Button, Modal, Box, useTheme } from "@mui/material";
import DataTable from "react-data-table-component";
import * as XLSX from 'xlsx';

import { useNavigate } from 'react-router-dom';
import { useTQuery } from '../../../utils/useTQuery';
import { useTMutation } from '../../../utils/useTMutation';
// import '../Profile/AdminStyling.css';
import { useSelector } from 'react-redux';
import showToast from '../../../components/Hot-Toast/showToast.js';
import { IoIosArrowRoundBack } from 'react-icons/io';


export const ImportUsers = () => {
    const { userDetails } = useSelector(state => state.user);
    const navigate = useNavigate();
    const [file, setFile] = useState();
    const [actualFile, setActualFile] = useState();
    const [fileErr, setFileErr] = useState(false);
    const [checkFileSize, setCheckFileSize] = useState(false);
    const [fileName, setFileName] = useState(false);
    const [phoneNuberExist, setPhoneNumberExist] = useState([]);
    const [emailExist, setEmailExist] = useState([]);
    const [url, setURl] = useState("/excelUploads")
    const [screenName, setScreenName] = useState("")
    const theme = useTheme();


    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 10,
        totalPage: 0,
    });



    const [values, setValues] = useState({
        ID: userDetails?.ID,
        USER_TYPE: 'clinician',
        FILTER_VALUE: "", SEARCH_PARMETER_LIST: ["USER_TYPE", "EMAIL_ADDRESS", "USER_STATUS"]
    });
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('type');
        if (paramValue) {

            values.USER_TYPE = paramValue
        }
        if (paramValue === "facility") setScreenName("Import Facility")
        else setScreenName("Import Clinician")

    }, [])
    const [row, setRow] = useState([]);

    const { data, isLoading, isError, error, refetch, isFetching } = useTQuery(
        ["user-management", values.FILTER_VALUE],
        `/mu/userMange?${new URLSearchParams({
            ...values,
            page: pagination.page + 1,
            rowsPerPage: pagination.rowsPerPage
        }).toString()}`,
        'get'
    );

    const mutation = useTMutation(url, 'post', (data) => {
        if (data) {
            return data
        }

    });

    const saveFile = (e) => {
        setFile(URL.createObjectURL(e.target.files[0]));
        setActualFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
        if (e.target.files[0].size > 3e+6) {
            setFileErr(true);
            setCheckFileSize(true)
        } else {
            setFileErr(false);
            setCheckFileSize(false);
        }
        e.target.value = null;
    };


    useEffect(() => {
        let formData = new FormData()
        formData.append('file', actualFile)
        formData.append('fileName', fileName)
        if (file) {
            setURl("/excelUploads")
            mutation.mutateAsync(formData).then(data => {
                if (data.OUTPUT.duplicatePhoneNumber) setPhoneNumberExist(data.OUTPUT.duplicatePhoneNumber)
                if (data.OUTPUT.duplicateEmail) setEmailExist(data.OUTPUT.duplicateEmail)
                setRow(data.OUTPUT.newLead)
            })
        }

    }, [file])


    const customStyles = {
        rows: {
            style: {
                minHeight: '45px',
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
        headCells: {
            style: {
                backgroundColor: '#f5f5f5',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
    };


    const columns = [
        {
            // name: 'First Name',
            name: <p style={{ fontSize: "12px" }}>First Name</p>,
            selector: row => row.FIRST_NAME,
            reorder: true,
        },
        {
            // name: 'LAST_NAME',
            name: <p style={{ fontSize: "12px" }}>Last Name</p>,
            selector: row => row.LAST_NAME,
            reorder: true,
        },
        {
            // name: 'Email Address',
            name: <p style={{ fontSize: "12px" }}>Email Address</p>,
            selector: row => row.EMAIL_ADDRESS,
            sortable: true,
            reorder: true,
            center: true
        },
        {
            // name: 'Phone Number',
            name: <p style={{ fontSize: "12px" }}>Phone Number</p>,
            selector: row => row.PHONE_NUMBER,
            sortable: true,
            reorder: true,
            center: true
        },
        {
            // name: 'Role Name',
            name: <p style={{ fontSize: "12px" }}>Role Name</p>,
            selector: row => row?.ROLE_NAME,
            sortable: true,
            reorder: true,
            center: true
        },

    ];
    const handleCloseModal = () => {
        setPhoneNumberExist([])
        setEmailExist([])
    }
    const downloadTemplate = () => {
        // Create sample data for the template
        const sampleData = [
            {
                FirstName: "John",
                LastName: "Doe",
                EmailAddress: "john.doe@example.com",
                PhoneNumber: "1234567890",
                RoleName: `Master ${values.USER_TYPE === "facility" ? "Facility" : "Clinician"}`
            },
            {
                FirstName: "Jane",
                LastName: "Smith",
                EmailAddress: "jane.smith@example.com",
                PhoneNumber: "0987654321",
                RoleName: `Master ${values.USER_TYPE === "facility" ? "Facility" : "Clinician"}`
            }
        ];

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(sampleData);
        
        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Users");
        
        // Generate filename based on user type
        const fileName = values.USER_TYPE === "facility" ? "facility_import_template.xlsx" : "clinician_import_template.xlsx";
        
        // Download the file
        XLSX.writeFile(wb, fileName);
    };
    const saveUser = () => {
        setURl("/uploadUserData")
        mutation.mutateAsync({ rowData: row, USER_TYPE: values.USER_TYPE }).then(data => {
            if (data && data.STATUS) {
                showToast("success", data.MESSAGE, 3000);
                navigate(screenName === "Import Facility" ? "/admin/facility-users" : "/admin/clinician-users")
            } else {
                showToast("error", data?.MESSAGE || "Something went wrong", 3000);
            }
        }).catch(error => {
            console.error("Error saving users:", error);
            showToast("error", "Failed to save users. Please try again.", 3000);
        })
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: 500 },
        maxWidth: 500,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
    };


    return (
        <Card>
            <Card elevation={0}>
                <Grid item xs={12} sx={{ mb: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            '&:hover': {
                                '& .MuiTypography-root': {
                                    color: theme?.palette?.primary?.main || '#1976d2'
                                }
                            }
                        }}
                        onClick={() => navigate(screenName === "Import Facility" ? "/admin/facility-users" : "/admin/clinician-users")}
                    >
                        <IconButton
                            sx={{
                                color: theme?.palette?.primary?.main || '#1976d2',
                                '&:hover': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                }
                            }}
                        >
                            <IoIosArrowRoundBack />
                        </IconButton>
                        <Typography
                            variant="body1"
                            sx={{
                                color: theme?.palette?.primary?.main || '#1976d2',
                                fontWeight: 500,
                                transition: 'color 0.2s ease-in-out'
                            }}
                        >
                            Back
                        </Typography>
                    </Box>
                </Grid>
                <Grid container spacing={2} sx={{ padding: "10px 0px" }} alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} md={6}>
                        <Typography variant="h2" component="div" fontWeight={"bold"} noWrap>
                            {screenName}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Download the template and fill in the required information. Required columns: FirstName, LastName, EmailAddress, PhoneNumber, RoleName
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-end' }, flexWrap: 'wrap' }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderColor: "#6EBE44",
                                    color: "#6EBE44",
                                    '&:hover': {
                                        borderColor: "#5aa035",
                                        backgroundColor: "#f5f9f5"
                                    },
                                    minWidth: '140px',
                                    height: '40px'
                                }}
                                onClick={downloadTemplate}
                            >
                                Download Template
                            </Button>

                            <Button
                                variant="contained"
                                component="label"
                                sx={{
                                    backgroundColor: "#6EBE44",
                                    '&:hover': {
                                        backgroundColor: "#5aa035"
                                    },
                                    minWidth: '100px',
                                    height: '40px'
                                }}
                            >
                                Import File
                                <input
                                    type="file"
                                    accept={['.xlsx', '.xls']}
                                    style={{ display: "none" }}
                                    onChange={saveFile}
                                />
                            </Button>

                            <Button
                                variant="contained"
                                disabled={row?.length === 0}
                                sx={{
                                    backgroundColor: row.length > 0 ? "#6EBE44" : "#cccccc",
                                    '&:hover': {
                                        backgroundColor: row.length > 0 ? "#5aa035" : "#cccccc"
                                    },
                                    '&:disabled': {
                                        backgroundColor: "#cccccc",
                                        color: "#666666"
                                    },
                                    minWidth: '100px',
                                    height: '40px'
                                }}
                                onClick={saveUser}
                            >
                                Save Users
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                <Grid item>
                    <Typography variant="h2" component="div" fontWeight={"bold"} noWrap>
                        {fileName}
                    </Typography>
                </Grid>


            </Card>


            <Card>
                <DataTable
                    className="table-items"
                    columns={columns}
                    data={row}
                    customStyles={customStyles}
                />
            </Card>
            <Modal
                open={phoneNuberExist.length > 0 || emailExist.length > 0}
                onClose={handleCloseModal}
                aria-labelledby="duplicate-modal-title"
                aria-describedby="duplicate-modal-description"
            >
                <Card sx={style}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography
                            id="duplicate-modal-title"
                            variant="h5"
                            component="h2"
                            sx={{
                                mb: 2,
                                color: 'error.main',
                                fontWeight: 'bold'
                            }}
                        >
                            Duplicate Records Removed
                        </Typography>

                        {phoneNuberExist.length > 0 && (
                            <Typography
                                variant="body1"
                                sx={{
                                    mb: 1,
                                    color: 'text.secondary',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <strong>Phone Numbers:</strong> {phoneNuberExist.join(', ')}
                            </Typography>
                        )}

                        {emailExist.length > 0 && (
                            <Typography
                                variant="body1"
                                sx={{
                                    mb: 3,
                                    color: 'text.secondary',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <strong>Emails:</strong> {emailExist.join(', ')}
                            </Typography>
                        )}

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                            <Button
                                variant="contained"
                                onClick={handleCloseModal}
                                sx={{
                                    backgroundColor: "#6EBE44",
                                    '&:hover': {
                                        backgroundColor: "#5aa035"
                                    },
                                    minWidth: '100px',
                                    height: '40px'
                                }}
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Card>
            </Modal>
        </Card>
    );
};

export default memo(ImportUsers);
